import { useEffect, useRef } from 'react';

import PropTypes from 'prop-types';
import shortid from 'shortid';

import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, InputAdornment } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import StyledTextField from '../Shared/StyledTextField';

const UseFocus = (inputRef = null) => {
  const searchRef = inputRef || useRef(null);
  const setFocus = () => {
    searchRef.current && searchRef.current.focus();
  };

  return [searchRef, setFocus];
};

const SearchComponent = (props) => {
  const { t } = useTransl();
  const {
    value,
    placeholder,
    onChange,
    disabled,
    inputRef,
    searchAutoFocus,
    showTableRowsOnly,
    ...rest
  } = props;

  const searchId = useRef(shortid.generate());

  const [searchRef, setSearchFocus] = UseFocus(inputRef);

  useEffect(() => {
    if (showTableRowsOnly) return;
    searchAutoFocus && setSearchFocus();
  }, [disabled]);

  const hasValue = inputRef ? searchRef?.current?.value : value;

  return (
    <StyledTextField
      id={searchId.current}
      value={value}
      placeholder={placeholder || t('title.search')}
      onChange={onChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="action" />
          </InputAdornment>
        ),
        endAdornment: hasValue && (
          <InputAdornment position="end">
            <IconButton
              aria-label={t('ariaLabel.clear')}
              onClick={() => onChange({ target: { value: '' } })}
              edge="end"
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
      inputRef={searchRef}
      disabled={disabled}
      {...rest}
    />
  );
};

SearchComponent.defaultProps = {
  placeholder: '',
  disabled: false,
  inputRef: null,
  searchAutoFocus: false,
  showTableRowsOnly: false,
};

SearchComponent.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  inputRef: PropTypes.instanceOf(Object),
  searchAutoFocus: PropTypes.bool,
  showTableRowsOnly: PropTypes.bool,
};
export default SearchComponent;
